module.exports = __webpack_public_path__ + "img/Step062.c8361efb.webp";